var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var minicartHelper = require('braintreebase/braintree/paypal/minicartHelper');

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
	// show add to cart toast

    if ($('.add-to-cart-messages').length === 0) {
        $('body').append(
			'<div class="add-to-cart-messages"></div>'
		);
    }

    $('.add-to-cart-messages').append(
		'<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
		+ response.message
		+ '</div>'
	);

    setTimeout(function () {
        $('.add-to-basket-alert').remove();
    }, 5000);
}

/**
 * Used to initiate ajax call and update the form
 * @param {Object} form - gift certificate form
 * @param {boolean} isUpdate - boolean value to check if it is update action
 * @return {boolean} false
 */
var updateGiftCertForm = function (form, isUpdate) {
    var url = form.attr('action');
    form.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        // eslint-disable-next-line consistent-return
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
            } else {
                if (!isUpdate) {
                    $('body').trigger('product:afterAddToCart', data);
                    handlePostCartAdd(data);
                    // form.find('input,textarea').val('');
                    return false;
                }
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            $('.error-messaging').html('');
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else if (isUpdate) {
                $('.error-gift-certificate').html('');
                createErrorNotification($('.error-gift-certificate'), err.responseJSON.message);
                $('.html, body').animate({
                    scrollTop: $('.error-gift-certificate').offset().top
                }, 1000);
            } else {
                createErrorNotification($('.error-messaging'), err.responseJSON.message);
            }
            form.spinner().stop();
        }
    });
    return false;
};

/**
 * Used to initiate ajax call and check gift card balance
 * @param {Object} form - check balance form
 */
var checkBalance = function (form) {
    var url = form.attr('action');
    form.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
            } else {
                $('#gift-balance-msg').html(data.giftCertificate.balance).removeClass('red');
            }
        },
        error: function (err) {
            form.spinner().stop();
            $('#gift-balance-msg').html(err.responseJSON.error).addClass('red');
        }
    });
};

module.exports = {
    addToBasket: function () {
        $('form.giftcert').submit(function (e) {
            e.preventDefault();
            $('#form-tcSelected-error').hide();
            var form = $(this);
            if ($('#tcSelected').prop('checked')) {
                updateGiftCertForm(form, false);
            } else {
                $('#form-tcSelected-error').show();
            }
        });
    },
    updateGiftCertificate: function () {
        $('body').on('click', '.update-gift-certificate', function (e) {
            var form = $(this).parent('.giftcert');
            e.preventDefault();
            updateGiftCertForm(form, true);
        });
    },
    checkGiftCertBalance: function () {
        $('body').on('click', '#CheckBalanceButton', function (e) {
            var form = $('.check-balance');
            e.preventDefault();
            checkBalance(form);
        });
    },
    updateMiniCartForGC: function () {
        // $('body').trigger('product:afterAddToCart', data);
        $(document).on('product:afterAddToCartGC', function (e, data) {
            if (!data.error) {
                var $actionElement = $('.js-action__minicart');
                var miniCartUrl = $actionElement.data('action-url');
                if (miniCartUrl) {
                    $.ajax({
                        url: miniCartUrl,
                        type: 'GET',
                        success: function (response) {
                            $actionElement.find('.js-mini-cart-section').html(response);
                            minicartHelper.miniCartButton();
                            $.spinner().stop();
                            if ($(window).width() >= 600) {
                                var minicart = document.querySelector('.minicart-total.siteheader__minicart-link.minicart-link');
                                minicart.click();
                            }
                        }
                    });
                }
            }
        });
    },
    handleAmountSelection: function () {
        $('.pre-select-amount li').click(function () {
            $(this).addClass('active').siblings().removeClass('active');
            $('.giftcert_purchase_amount').addClass('d-none');
            var productid = $(this).attr('data-productid');
            $('#giftCertProductID').val(productid);
        });
    },
    handleTermsAndCondition: function () {
        $(document).ready(function () {
            $('.pre-select-amount li:first').trigger('click');
        });

        $('#tcSelected').change(function () {
            $('#submit-gift-cert').attr('disabled', 'disabled');
            if (this.checked) {
                $('#submit-gift-cert').removeAttr('disabled');
            }
        });
    }
};
